import { destructureControlId } from '@avantia/questionset-model';
import { BaseSyntheticEvent } from 'react';
import { HpGetEventFunction } from '../../actions/eventActionTypes';
import { getEventDetail } from '../../tools/utilities';
import { HpClientQuestionUI } from '../../types';
import { HpFormName } from '../../types/actionTypes';
import { HpEventDetail, HpEventDetailTypes } from '../../types/inputControlTypes';
import { HpQuestionSetPageProps } from '../../types/questionSetPagePropTypes';
import { HpEventTypeProcessor, HpHandleFormEventProps, HpHandleMouseEventProps } from './eventProcessor';

export class FluentFieldProcessor implements HpEventTypeProcessor<HpQuestionSetPageProps> {
  canHandle(detailType: HpEventDetailTypes): boolean {
    return detailType && detailType.startsWith('fluent-');
  }

  handleFocusEvent(): void {
    throw new Error('Method not implemented.');
  }

  handleMouseEvent({ event, detail, pageProps, formName }: HpHandleMouseEventProps<HpQuestionSetPageProps>): void {
    this.fieldChangedCommon(event, detail, pageProps, formName);
  }

  handleFormEvent({ event, detail, pageProps, formName }: HpHandleFormEventProps<HpQuestionSetPageProps>): void {
    this.fieldChangedCommon(event, detail, pageProps, formName);
  }

  handleKeyboardEvent(): void {
    throw new Error('Method not implemented.');
  }

  private fieldChangedCommon(
    event: BaseSyntheticEvent,
    detail: HpEventDetail,
    pageProps: HpQuestionSetPageProps,
    formName: HpFormName
  ): void {
    const getEvent: HpGetEventFunction = () => event;
    const { question, type: detailType } = detail;
    const { target } = getEventDetail(event);
    const { questionId: targetId, key } = destructureControlId(target.id);
    if (detailType === 'fluent-change' || detailType === 'fluent-click') {
      let value = target.value;
      const { validationResult } = pageProps;
      const error = validationResult.errors[targetId];
      let ui: Partial<HpClientQuestionUI> = {};
      if (detailType === 'fluent-click') {
        value = key as string;
        ui = { isEditing: false };
      }

      pageProps.fieldChanged({
        getEvent,
        key: targetId,
        value,
        error,
        formName,
        ui,
        question,
        detail,
        getQuestionSet: () => pageProps
      });
    } else if (detailType === 'fluent-ok' || detailType === 'fluent-toggle') {
      pageProps.fluentAnswerClick({
        getEvent,
        targetId,
        formName,
        fluentAction: detailType === 'fluent-ok' ? 'ok' : 'open'
      });
    } else {
      throw new Error(`Unhandled type "${detailType}".`);
    }
  }
}
